const siteDetail = {
  details_heading_text: "Project Details",
  project_name: "Project Name",
  account_manager: "Account Manager",
  project_lead: "Project Lead",
  project_owner: "Project Owner",
  project_org: "Project Organization",
  project_add: "Address",
  edit_project_detail: "Edit project details",
  heading_contact: "Contact Details",
  logo: "Logo",
  home_page_banner: "Home Banner",
  details_image_text: "Images & Home Screen",
  label_sitename: "Project Name",
  label_siteadd: "Project Address",
  label_siteOwner: "Project Owner",
  label_siteOrg: "Project Organization",
  label_accManager: "Account Manager",
  label_hubspot: "Hubspot Link",
  label_home_banner: "Home Banner",
  label_region: "Region",
  error_valid_email: "Hmm… that email doesn't look valid",
  error_region_required: "Region is required",
  label_home_screen_message: "Home Screen Message",
  error_image_invalid: "Please upload valid image file",
  error_siteLogo_required: "Site Logo is required",
  error_homebanner_required: "Banner Image is required",
  error_sitename_required: "Project Name is required",
  error_siteadd_required: "Project Address is required",
  error_siteowner_required: "Project Owner is required",
  error_siteorg_required: "Project Organization is required",
  error_acc_manager_required: "Account Manager is required",
  error_hubspot_url: "Hubspot Url is required",
  error_something_went_wrong: "Something Went Wrong...",
  error_homemessage_required: "Home Screen Message is required",
  error_email_required: "Email is required",
  // contact
  contact_heading_text: "Contacts",
  add_contact: "Add New Contact",
  edit_contact: "Edit Contact",
  label_name: "Name",
  label_position: "Position",
  label_phone: "Phone Number (Optional)",
  btn_add: "Add",
  btn_remove: "Remove",
  btn_edit: "Edit",
  btn_save: "Save",
  error_name_required: "Name is required",
  error_position_required: "Position is required",
  error_valid_phonenumber: "Please enter valid Phone Number",
  error_required_phone: "Phone is required",
  drag_and_drop: "Drag and drop your files or",
  browse_file: "BROWSE FILES",
  image_uploading: "Uploading Image",
};
export default siteDetail;
